import { Dispatch } from "redux";
import { ActionType } from "../actions/ActionTypes";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const GetCurrentPlan = (uid: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.GET_CURRENT_PLAN_INIT });
      const url = `${BASE_URL}/subscription/plan/${encodeURIComponent(uid)}`;
      const response = await axios.get(url);
      dispatch({
        type: ActionType.GET_CURRENT_PLAN_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      toast.error("An unexpected error occurred");
      dispatch({
        type: ActionType.GET_CURRENT_PLAN_FAIL,
        payload: "An unexpected error occurred",
      });
    }
  };
};

export const GetUpcommingPlan = (uid: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.GET_UPCOMING_PLAN_INIT });
      const url = `${BASE_URL}/subscription/upcoming-plan/${encodeURIComponent(
        uid
      )}`;
      const response = await axios.get(url);
      dispatch({
        type: ActionType.GET_UPCOMING_PLAN_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      const status = error?.response?.status;

      if (status !== 404) {
        toast.error("An unexpected error occurred");
      }

      dispatch({
        type: ActionType.GET_UPCOMING_PLAN_FAIL,
        payload: "An unexpected error occurred",
      });
    }
  };
};
